module.exports = __webpack_public_path__ + "static/img/man.334dacb6.jpeg";